import { Headphones, LogIn, MicOff, XCircle } from 'lucide-react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/services/api';
import { Card, CardHeader } from '@/components/ui/card';
import { DataTable } from '@/components/tables/data-table';
import { Badge } from '@/components/ui/badge';
import { EmptyState } from '@/components/ui/empty-state';
import { useToast } from '@/components/ui/toast';
import { PageHeader } from '@/components/ui/page-header';
import { ActionMenu } from '@/components/ui/action-menu';

export function VoiceRoomsPage() {
  const client = useQueryClient();
  const toast = useToast();
  const query = useQuery({ queryKey: ['admin-voice-rooms'], queryFn: () => api('/api/v1/admin/voice-rooms').then((result) => result.data) });
  const refresh = () => client.invalidateQueries({ queryKey: ['admin-voice-rooms'] });
  const action = async (groupId, name) => {
    await api(`/api/v1/admin/voice-rooms/${groupId}/${name}`, { method: 'POST' });
    await refresh();
    toast.show(name === 'close' ? 'Voice room closed' : 'Mute-all event sent');
  };
  const visibleJoin = async (groupId) => {
    await api(`/api/v1/admin/voice-rooms/${groupId}/token`);
    toast.show('Visible admin join token issued and participants notified');
  };
  const rows = query.data ?? [];
  const active = rows.filter((row) => row.status === 'active').length;
  const columns = [
    { key: 'room', header: 'Room', cell: (row) => <div><p className="text-xs font-bold text-slate-200">{row.livekitRoomName}</p><p className="text-[10px] text-slate-600">Group {row.groupId}</p></div> },
    { key: 'mode', header: 'Microphone', cell: (row) => <span className="text-xs capitalize text-slate-400">{row.microphoneMode}</span> },
    { key: 'status', header: 'Status', cell: (row) => <Badge tone={row.status === 'active' ? 'success' : 'neutral'}>{row.status}</Badge> },
    { key: 'actions', header: '', width: 70, sortable: false, exportable: false, cell: (row) => <ActionMenu actions={row.status === 'active' ? [
      { label: 'Join visibly', icon: LogIn, onClick: () => void visibleJoin(row.groupId) },
      { label: 'Mute all', icon: MicOff, onClick: () => void action(row.groupId, 'mute-all') },
      { label: 'Close room', icon: XCircle, danger: true, onClick: () => void action(row.groupId, 'close') },
    ] : []}/> },
  ];

  return <div className="workspace-page">
    <PageHeader eyebrow="Rider Link" title="Voice Rooms" description="Monitor and moderate group intercom rooms." meta={<Badge tone={active ? 'success' : 'neutral'}>{active} active</Badge>}/>
    <Card className="workspace-fill"><CardHeader eyebrow="LiveKit intercom" title="Room directory" action={<Headphones size={15} className="text-cyan-300"/>}/>{rows.length ? <DataTable tableId="voice-rooms" rows={rows} columns={columns} getKey={(row) => row._id} onRefresh={() => query.refetch()} loading={query.isFetching} searchPlaceholder="Search voice room or status"/> : <EmptyState title={query.isLoading ? 'Loading rooms...' : 'No voice rooms'}/>}</Card>
  </div>;
}
